import type { ColorsThemeConfig } from '../../types/themed/colors.types';
import type { TextsThemeConfig } from '../../types/themed/texts.types';
import type { TourThemeConfig } from '../../types/themed/tour.types';

import TourTheme from '../tour/styles/themes/minimal.styled.theme';

import { generateTextStyle } from './utils/generate-text-style';
import { getRGBAColorWithOpacity } from './utils/get-rgba-color-with-opacity';

import { deviceSize } from '../../style/responsive.styled';

interface TourOptionsThemeConfig {
  hideHeroImage?: boolean;
}

export function generateTourTheme(
  colors: ColorsThemeConfig,
  texts: TextsThemeConfig,
  options: TourOptionsThemeConfig = {}
): TourThemeConfig {
  return {
    font_family: texts.default.fontFamily,
    additional_css: 'text-align: center;',
    title: {
      ...generateTextStyle(texts.default),
      ...generateTextStyle(texts.header),
      color: colors.accent,
      top: '40px',
    },
    subtitle: {
      ...generateTextStyle(texts.default),
      ...generateTextStyle(texts.descriptions.regular),
      color: colors.primary,
      padding: '10%',
      tablet: {
        ...generateTextStyle(texts.default),
        ...generateTextStyle(texts.descriptions.regular),
        color: colors.primary,
      },
    },
    cta_button: {
      ...TourTheme.cta_button,
      ...generateTextStyle(texts.default),
      ...generateTextStyle(texts.buttons),
      desktop: {
        ...generateTextStyle(texts.default),
        ...generateTextStyle(texts.buttons),
      },
      background: colors.accent,
      additional_mq: {
        ...TourTheme.cta_button.additional_mq,
        [deviceSize.mobileM]: `
          width: 159px;
          min-width: fit-content;
          max-width: 50%;
        `,
      },
    },
    gallery_text_box: {
      ...TourTheme.gallery_text_box,
      ...generateTextStyle(texts.default),
      ...generateTextStyle(texts.descriptions.regular),
      padding: '3em 0 1em',
      sticky_background: getRGBAColorWithOpacity(colors.accent, '0.7'),
      color: colors.accent,
      sticky_color: colors.primaryInverted,
      tablet: {
        padding: 'unset',
        background: colors.accent,
        color: colors.primaryInverted,
      },
    },
    close_btn: {
      ...TourTheme.close_btn,
      mobile: {
        ...TourTheme.close_btn.mobile,
        icon_color: colors.primaryInverted,
      },
      desktop: {
        ...TourTheme.close_btn.desktop,
        icon_color: colors.secondary,
      },
    },
    hero_image: {
      ...TourTheme.hero_image,
      ...(options.hideHeroImage ? {
        url: '',
        height: '0',
        additional_css: 'display: none;',
      } : {}),
    },
  };
}
